export class Filter{
    Name: string;
    Checked: boolean;
    Expression: string;
    constructor(name: string, checked: boolean, expression: string){
        this.Name = name;
        this.Checked = checked;
        this.Expression = expression;
    }
}